<script>
    import Profile from './Profile.svelte'
    import Clients from './clients/Container.svelte'

	import {Router, Route, Link, navigate} from 'svelte-routing'

    import { auth, googleProvider } from '../lib/firebase'
    import { authState } from 'rxfire/auth'

    let user

    const unsubscribe = authState(auth).subscribe(u => user = u)

    function login() {
        auth.signInWithPopup(googleProvider)
    }
</script>


<style>
section {
    margin-top: 4rem;
    background: rgb(235, 235, 235);
    padding: 20px;
}
</style>

<section class="container">
{#if user}
    <Profile {...user} />
    <button on:click={ () => auth.signOut() } class="button">Logout</button>
    <hr>
    <!-- <PlayerClasses uid={user.uid} />  -->
    <!-- <PlayerCharacters /> -->
    <Router>
        <nav>
            <Link to="/">Home</Link>
            <Link to="/clients">Clients</Link>
        </nav>
        <hr>
        <Route exact path="/clients" component={Clients} />
        <!-- <Route exact path="/characters" component={PlayerCharacters} /> -->
        <!-- <Route path="/characters/:id" component="{CharacterSheet}" /> -->
    </Router>
{:else}
	<button on:click={login} class="button">
		Signin with Google
	</button>
{/if}
</section>